import { render, staticRenderFns } from "./long-title-nofoot.vue?vue&type=template&id=3f70c880&scoped=true"
import script from "./long-title-nofoot.vue?vue&type=script&lang=js"
export * from "./long-title-nofoot.vue?vue&type=script&lang=js"
import style0 from "./long-title-nofoot.vue?vue&type=style&index=0&id=3f70c880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70c880",
  null
  
)

export default component.exports